import { render, staticRenderFns } from "./EditBoxType.vue?vue&type=template&id=6e8c9a02&"
import script from "./EditBoxType.vue?vue&type=script&lang=js&"
export * from "./EditBoxType.vue?vue&type=script&lang=js&"
import style0 from "./EditBoxType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports